// extracted by css-extract-rspack-plugin
export default {"UpsellBigCardComponent":"AHzB6"};